export class Events {
  static INSURANCE_TUTORIAL = 'insurance tutorial';
}

export class Actions {
  static SHOW_TUTORIAL_CARD = 'show card';

  static CLICK_VIEW_TUTORIAL = 'click view tutorial';

  static SHOW_ENTRY_POINT_CARD = 'show entry point card';

  static SHOW_ENTRY_POINT_MODAL = 'show entry point modal';

  static CLICK_BACK = 'click back';

  static CLICK_CLOSE = 'click close';

  static CLICK_NEXT = 'click next';
}

export class Sources {
  static TUTORIAL_ENTRY_POINT_MODAL = 'tutorial entry point modal';

  static TUTORIAL_CARD = 'tutorial card';
}
